import type { PayloadAction } from '@reduxjs/toolkit';
import type { MedNecCaseSliceState } from '../state';
import type { MedNecCaseView } from '../../types/medNecTypes';

export const coreReducers = {
  setCurrentCase: (state: MedNecCaseSliceState, action: PayloadAction<MedNecCaseView>) => {
    state.currentCase = action.payload;
    state.selectedCaseId = action.payload.id;
    state.isEdited = false;
    state.editedFields = [];
  },

  updateCase: (state: MedNecCaseSliceState, action: PayloadAction<Partial<MedNecCaseView>>) => {
    if (state.currentCase) {
      state.currentCase = { ...state.currentCase, ...action.payload };
      Object.keys(action.payload).forEach((field) => {
        if (!state.editedFields.includes(field)) {
          state.editedFields.push(field);
        }
      });
      state.isEdited = true;
    }
  },

  clearCase: (state: MedNecCaseSliceState) => {
    state.currentCase = null;
    state.serverCase = null;
    state.selectedCaseId = null;
    state.isEdited = false;
    state.editedFields = [];
  },

  setSelectedCaseId: (state: MedNecCaseSliceState, action: PayloadAction<string | null>) => {
    state.selectedCaseId = action.payload;
  },
};
